import React, {Component} from 'react'
import Card from "Utils/Cards/Card"
import PendientesSolidos from './PendientesSolidos';

export default class PendientesValidacionList extends Component{
    componentWillMount() {
        const { setTab } = this.props;
        setTab('SÓLIDOS', 'validar');
    }

    render() {
        const { data_solido_validar: data } = this.props;
        return(
            <div className="mb-4 col-12">
                <Card
                    icon="laboratorio_activo"
                    titulo="PENDIENTES"
                    subtitulo="Validar DRC Sólido"
                >
                    <PendientesSolidos dataSolidos={data} {...this.props}/>
                </Card>
            </div>
        )
    }
}
